import type { BuildingFinishesSections } from "../../../types/buildings-sections/finishes";

export const finishes: BuildingFinishesSections = {
  title: "Finishes",
  description: "Building finishes information",
  noDataAvailable: "Finishes data not available",
  material: "Material",
  color: "Colour",
  manufacturer: "Manufacturer",
  installationDate: "Installation Date",
  durabilityRating: "Durability Rating",
  warrantyInfo: "Warranty Info",
  maintenanceRequirements: "Maintenance Requirements",
  noFinishes: "No finishes",
  addFinish: "Add Finish",
  editFinish: "Edit Finish",
  deleteFinish: "Delete Finish",
  floorings: "Floorings",
  walls: "Walls",
  ceilings: "Ceilings",
  doors: "Doors",
  windows: "Windows",
  other: "Other Finishes",
};
